module.exports = __webpack_public_path__ + "static/media/coffeesugano.e197925b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/coffeesugano.jpg
// module id = 463
// module chunks = 0